import { useContext } from 'react';

export const useSafeContext = <T>(context: React.Context<T>) => {
  const value = useContext(context);

  /* istanbul ignore next */
  if (!value) throw new Error(`useSafeContext must be used within a Provider`);

  return value;
};
